function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import CheckIcon from '@mui/icons-material/Check';
import { StyledContainer, StyledText } from './StepIcon.styled';
function StepIcon(_ref) {
  var active = _ref.active,
    completed = _ref.completed,
    error = _ref.error,
    icon = _ref.icon;
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('sm');
  });
  var commonProps = {
    active: active,
    completed: completed,
    error: error,
    isMobile: isMobile
  };
  return /*#__PURE__*/React.createElement(StyledContainer, commonProps, function () {
    if (error) {
      return /*#__PURE__*/React.createElement(StyledText, _extends({
        align: "center"
      }, commonProps), "!");
    }
    if (completed && !active) {
      return /*#__PURE__*/React.createElement(CheckIcon, null);
    }
    return /*#__PURE__*/React.createElement(StyledText, _extends({
      align: "center"
    }, commonProps), icon);
  }());
}
StepIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool.isRequired,
  /**
   * Mark the step as completed.
   */
  completed: PropTypes.bool.isRequired,
  /**
   * Whether this step has an error.
   */
  error: PropTypes.bool.isRequired,
  /**
   * Which step are we displaying
   */
  icon: PropTypes.node.isRequired
} : {};
export default StepIcon;